<template>
	<!-- come la barra della dashboard, ma solo per mesi interi: il report e' fatto di fotografie mensili -->
	<v-card outlined class="period-bar px-3 py-2" data-tour="period">
		<div class="d-flex flex-wrap align-center" style="gap: 8px 12px">
			<v-btn-toggle :value="value.period" mandatory dense color="primary" @change="update({ period: $event })">
				<v-btn small value="month">Mese</v-btn>
				<v-btn small value="quarter">Trimestre</v-btn>
				<v-btn small value="year">Anno</v-btn>
			</v-btn-toggle>

			<v-select v-if="value.period === 'month'" :value="value.month" :items="months" label="Mese" dense outlined hide-details class="field-sm" @change="update({ month: $event })" />
			<v-select v-if="value.period === 'quarter'" :value="value.quarter" :items="quarters" label="Trimestre" dense outlined hide-details class="field-xs" @change="update({ quarter: $event })" />
			<v-select :value="value.year" :items="years" label="Anno" dense outlined hide-details class="field-xs" @change="update({ year: $event })" />

			<v-select :value="value.compare" :items="compares" label="Confronta con" dense outlined hide-details class="field-md" @change="update({ compare: $event })" />
			<v-select :value="value.platform" :items="platformItems" label="Canale" dense outlined hide-details class="field-sm" data-tour="platform" @change="update({ platform: $event })" />

			<v-spacer />
			<span v-if="refreshLabel" class="text-caption grey--text text--darken-1">{{ refreshLabel }}</span>
			<v-btn small outlined color="primary" :loading="loading || refreshing" :disabled="refreshing" title="Ricalcola i mesi del periodo con i dati di oggi" @click="$emit('refresh')">
				<v-icon small left>mdi-refresh</v-icon>
				Aggiorna
			</v-btn>
		</div>
		<!-- avanzamento di "Aggiorna": il ricalcolo dei mesi gira in coda -->
		<v-progress-linear v-if="refreshing" :value="refreshProgress" :indeterminate="!refreshProgress" color="primary" height="3" class="mt-2" />
	</v-card>
</template>

<script>
import { MONTHS } from '@/components/dashboard/format';

export default {
	name: 'FinancePeriodBar',
	props: {
		value: { type: Object, required: true },
		platforms: { type: Array, default: () => [] },
		loading: { type: Boolean, default: false },
		refreshing: { type: Boolean, default: false },
		refreshProgress: { type: Number, default: 0 },
		refreshLabel: { type: String, default: '' },
	},
	data() {
		const current = new Date().getFullYear();
		return {
			months: MONTHS,
			quarters: [1, 2, 3, 4].map(q => ({ value: q, text: `Q${q}` })),
			years: Array.from({ length: 6 }, (_, i) => current - i),
			compares: [
				{ value: '', text: 'Nessun confronto' },
				{ value: 'prev', text: 'Periodo precedente' },
				{ value: 'yoy', text: 'Stesso periodo anno prima' },
			],
		};
	},
	computed: {
		platformItems() {
			return [{ value: '', text: 'Tutti i canali' }, ...this.platforms.map(p => ({ value: p, text: p }))];
		},
	},
	methods: {
		update(patch) {
			this.$emit('input', { ...this.value, ...patch });
		},
	},
};
</script>

<style scoped>
.field-xs {
	max-width: 110px;
}
.field-sm {
	max-width: 160px;
}
.field-md {
	max-width: 230px;
}
</style>
